
import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import './globalFilters';
import './globalFunctions';

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import VueTheMask from "vue-the-mask";
import AsyncComputed from 'vue-async-computed';
import VueChatScroll from 'vue-chat-scroll';

// router setup
import routes from "./router/index.js";

// Session checker for router guard
import session from "./models/session.vue";

// plugin setup
Vue.use(AsyncComputed)
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueTheMask);
Vue.use(VueChatScroll);

// configure router
const router = new VueRouter({
	mode: "history",
	routes, // short for routes: routes
	linkExactActiveClass: "nav-item active",
});

// Global router guard to prevent acces from non admin users
router.beforeEach(async (to, from, next) => {
	if (to.name === "Login") {
		next();
	} else {
		if (await session.isActive()) {
			next();
		} else {
			session.clear();
			next("/login");
		}
	}
});

window.vueRouter = router;

router.beforeEach(async (to, from, next) => {
	if (await session.isActive() || to.path === "/login"){
		next();
	} else {
		session.setItem("originalUrl", to.path);
		next("/login");
	}
});

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
	get () {
		return this.$root.Chartist;
	}
});

new Vue({
	el: "#app",
	render: h => h(App),
	router,
	data: {
		Chartist: Chartist
	},
});
